export const masterFirebaseConfig = {
  apiKey: "AIzaSyBkQJJYAEL8JeNWZdoTQRSmFmUGlHLdFP4",
  authDomain: "underarmour-rebuild-6546c.firebaseapp.com",
  databaseURL: "https://underarmour-rebuild-6546c.firebaseio.com",
  projectId: "underarmour-rebuild-6546c",
  storageBucket: "underarmour-rebuild-6546c.appspot.com",
  messagingSenderId: "261452863157"
}



// WEBPACK FOOTER //
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/src/app/api-keys.ts